import { TENANT_BRANDING } from './branding.js';

export const TENANT_CONFIG = {
  ...TENANT_BRANDING,
  billingPlan: 'enterprise',
  // Tenant = cliente. Los módulos pertenecen a QorIAX SaaS y aquí solo se contratan/habilitan.
  moduleEntitlements: {
    dashboard: { enabled: true, label: 'Centro de Control' },
    reception: { enabled: true, label: 'Recepción y Turnos' },
    appointments: { enabled: true, label: 'Turnos' },
    specialists: { enabled: true, label: 'Profesionales' },
    telemedicine: { enabled: true, label: 'Telemedicina' },
    surgery: { enabled: true, label: 'Quirófano' },
    inpatient: { enabled: true, label: 'Internación' },
    multichat: { enabled: true, label: 'MultiChat' },
    patient_portal: { enabled: true, label: 'Portal Paciente' },
    tenant_management: { enabled: true, label: 'Gestión del Tenant' },
    clinical_workspace: { enabled: true, label: 'Consultorio', adapter: 'qoriax_native' },
    specialist_workspace: { enabled: true, label: 'Especialistas' },
    diagnostics_laboratory: { enabled: true, label: 'Laboratorio' },
    diagnostics_imaging: { enabled: true, label: 'Imágenes' },
    gasparini_integration: { enabled: true, label: 'Integración Gasparini' }
  },
  healthServices: {
    inpatient_general: { serviceState: 'active', rollout: 'canary', visible: true },
    icu_adult: { serviceState: 'off', rollout: 'off', visible: false },
    icu_neoped: { serviceState: 'off', rollout: 'off', visible: false },
    day_hospital_oncology: { serviceState: 'off', rollout: 'off', visible: false },
    day_hospital_nephrology: { serviceState: 'off', rollout: 'off', visible: false },
    day_hospital_general: { serviceState: 'off', rollout: 'off', visible: false },
    cath_lab: { serviceState: 'off', rollout: 'off', visible: false },
    observation: { serviceState: 'off', rollout: 'off', visible: false },
    post_anesthesia_care: { serviceState: 'active', rollout: 'shadow', visible: true }
  },
  channels: {
    whatsapp: { enabled: true, instance: 'qoriax-clara' },
    web_chat: { enabled: true }
  }
};

export default TENANT_CONFIG;
